<template>
  <ModalTemplate size="md" :modal="modal" :closable="true">
    <div class="pb-3 md:pb-5 md:pt-2">
      <p class="mb-1 text-lg font-medium md:text-xl">
        {{ $t('routes.Projects') }}
      </p>
    </div>
    <div class="grid gap-2 pb-4">
      <CatalogCardMini
        v-for="item in catalogs.items"
        :key="item.id"
        :catalog="item"
      >
      </CatalogCardMini>
    </div>
  </ModalTemplate>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import ModalTemplate from '@/components/modal/ModalTemplate.vue';
import CatalogCardMini from '@/components/cards/CatalogCardMini.vue';

export default {
  name: 'CatalogSelectModal',
  components: {
    ModalTemplate,
    CatalogCardMini,
  },
  props: {
    modal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['catalogSettings', 'catalogs']),
  },
  mounted() {},
  methods: {
    ...mapActions(['CLOSE_MODAL']),
  },
};
</script>
